import React, { useState } from 'react'
import { Button } from '@blueprintjs/core'
import { Popover2 } from '@blueprintjs/popover2'
import { TaskT, TaskActionTypeT, TaskActionT } from 'ui-io/task-io/task-t'

import TaskPageContextMenu from './task-page-context-menu'
import EditTaskDialog from './edit-task-dialog'
import FastlaneTaskDialog from './fastlane-task-dialog'
import ModifyAssignmentDialog from '../../components/task/tasks-table/modify-assignment-dialog'
// import getNextView from '../../components/tasks-table/get-next-view'
import getNextView from '../../components/task/tasks-table/get-next-view'
import {
  BlockTaskDialog,
  // EscalateTaskDialog,
  CloseTaskDialog,
  UnblockTaskDialog,
  RejectToEdit,
} from '../../components/task-actions'
import { InboxViewT } from '../tasks/inbox-views'
// import { InboxViewT } from '../inbox-page/inbox-views'

export type ContextMenuModelT =
  | 'BLOCK'
  | 'UNBLOCK'
  | 'ESCALATE'
  | 'CLOSE'
  | 'REJECT_TO_EDIT'
  | 'FASTLANE_TASK'
  | undefined

const TaskExtraActions = ({
  task,
  prevInboxView,
}: {
  task: TaskT
  prevInboxView?: InboxViewT
}) => {
  const [taskAction, setTaskAction] = useState<TaskActionT | null>(null)
  const [activeModel, setActiveModel] = useState<ContextMenuModelT>(undefined)

  const closeModel = () => {
    setActiveModel(undefined)
  }

  const openModel = (model: ContextMenuModelT) => {
    setActiveModel(model)
  }

  const contextMenu = (
    <TaskPageContextMenu
      task={task}
      setTaskAction={(actionType: TaskActionTypeT) => {
        setTaskAction && setTaskAction({ task, actionType })
      }}
      openModel={openModel}
    />
  )
  const assignmentType = !!taskAction ? getNextView(taskAction.task) : undefined

  return (
    <>
      <Popover2 content={contextMenu} position="bottom">
        <Button icon="more" />
      </Popover2>
      {!!taskAction?.task && taskAction.actionType !== 'EDIT' && (
        <ModifyAssignmentDialog
          {...{
            task: taskAction.task,
            actionType: taskAction.actionType,
            setTaskAction: () => {
              setTaskAction(null)
            },
            assignmentType,
          }}
        />
      )}
      {taskAction?.task && (
        <EditTaskDialog
          isOpen={taskAction.actionType === 'EDIT'}
          task={taskAction.task}
          onClose={() => {
            setTaskAction(null)
          }}
        />
      )}
      <BlockTaskDialog
        task={task}
        isModalOpen={activeModel === 'BLOCK'}
        toggleModal={closeModel}
      />
      {/* <EscalateTaskDialog
        task={task}
        isModalOpen={activeModel === 'ESCALATE'}
        toggleModal={closeModel}
      /> */}
      <CloseTaskDialog
        task={task}
        isModalOpen={activeModel === 'CLOSE'}
        toggleModal={closeModel}
        prevInboxView={prevInboxView}
      />
      <UnblockTaskDialog
        task={task}
        isModalOpen={activeModel === 'UNBLOCK'}
        toggleModal={closeModel}
      />

      {/* <RejectToEdit
        task={task}
        isModalOpen={activeModel === 'REJECT_TO_EDIT'}
        toggleModal={closeModel}
      /> */}
      <FastlaneTaskDialog
        task={task}
        isModalOpen={activeModel === 'FASTLANE_TASK'}
        toggleModal={closeModel}
      />
    </>
  )
}

export default TaskExtraActions
